/**
 * Frontend-only presentation states. Callers map a row's API `meta` onto these,
 * so adding a state doesn't change the API contract.
 */
const AVAILABLE = 'available'
const NOT_AVAILABLE = 'not_available'
const CURRENT = 'current'

export const suggestionStates = Object.freeze({
    AVAILABLE,
    // Committed elsewhere: shown struck out, not choosable.
    NOT_AVAILABLE,
    // Already belongs to the record being edited: choosable, since re-adding it is a no-op.
    CURRENT,
})

export const available = Object.freeze({ state: AVAILABLE, label: '' })

/**
 * @param {string} label why it cannot be taken, in the reader's terms
 * @param {string} state
 * @returns {{state: string, label: string}}
 */
export const unavailable = (label = '', state = NOT_AVAILABLE) => Object.freeze({ state, label })

/**
 * CURRENT counts as selectable: re-adding it restores what the server already has.
 *
 * @param {{state: string}|null} status
 * @returns {boolean}
 */
export const isSelectable = (status) => !status || status.state === AVAILABLE || status.state === CURRENT
